// import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import Pathalogy from "./pathalogy"

const PathalogyContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Pathalogy />
      </div>
    </div>
  )
}

export default PathalogyContainer